module.exports = __webpack_public_path__ + "img/underwear_thong.e34c52a4.png";